import { AuthErrorMessages } from 'src/store/reducers/AuthReducer/types'

export const mapFirebaseError = (error: string): AuthErrorMessages => {
  const errorCodeMatch = error.match(/\(auth\/(.+?)\)/)
  const errorCode = errorCodeMatch ? `auth/${errorCodeMatch[1]}` : error

  const errorMessages: Record<string, string> = {
    'auth/email-already-in-use': 'emailAlreadyInUse',
    'auth/invalid-email': 'invalidEmail',
    'auth/user-not-found': 'userNotFound',
    'auth/wrong-password': 'wrongPassword',
    'auth/weak-password': 'weakPassword',
    'auth/network-request-failed': 'networkRequestFailed',
    'auth/invalid-credential': 'invalidCredential',
  }

  return (errorMessages[errorCode] || 'unknownError') as AuthErrorMessages
}
